import DotStatus from "../components/DotStatus";

/**
 * Props do modal de cadastro embutido nos selects (`create`): `true` usa o
 * padrão do select; um objeto repassa tipo, nível etc. ao modal.
 */
export const createModalProps = create => (create === true ? {} : create);

export const getLabelFromOptions = (options, value) => {
    const option = options.find(option => option.value === value);
    return option ? option.label : '';
}

export const createOptions = (array, label = null, value = null, nullable = false, valueToExclude = null, labelNullable = 'Nenhuma opção') => {
    array = Array.isArray(array) ? array : [];
    let options = [];

    if(nullable){
        options.push({
            value: null,
            label: labelNullable
        });
    }

    const getLabelText = item => {
        let labelText = '';

        if(label === null){
            labelText = item;
        } else if(Array.isArray(label)){
            let labels = [];
            label.map(l => {
                labels.push(item[l]);
            });
            labelText = labels.join(' - ');
        } else {
            labelText = item[label];
        }

        return labelText;
    }

    array.map(item => {
        let hasItem = options.filter(o => o.value === item[value]).length === 0 ? false : true;
        if(!hasItem){
            options.push({
                label: getLabelText(item),
                value: value === null ? item : item[value]
            })
        }
    });

    if(valueToExclude !== null){
        options = options.filter(option => option.value !== valueToExclude)
    }

    return options;
}

export const createStatusOptions = (statuses, nullable = true) => {
    let options = [];

    // if(nullable){
    //     options.push({
    //         value: null,
    //         label: 'Nenhuma opção'
    //     });
    // }

    statuses.map(status => {
        options.push({
            label: <span><DotStatus color={status?.color} size={15} />{status?.name}</span>,
            value: status.id
        })
    });

    return options;
}

export const createProductOptions = (array, label = null, value = null, nullable = false) => {
    let options = [];

    if(nullable){
        options.push({
            value: null,
            label: 'Nenhuma opção'
        });
    }

    array.map(item => {
        let itemValue = value === null ? item.id : item[value];
        let hasItem = options.some(o => o.value === itemValue);
        if(!hasItem){
            let labelImage = item.image ? <img src={item.image.image_url.small} /> : <img src={ require(`../assets/images/svgs/default.svg`).default } />;
            let labelText = item.sku + ' - ' + item.name;
            options.push({
                label: labelText,
                value: value === null ? item : item[value],
                image: labelImage
            })
        }
    });

    return options;
}
